module.exports = __webpack_public_path__ + "img/banner02.a6bf416a.png";